<script setup lang="ts">
  import { AlertDialogRoot, useForwardPropsEmits } from "reka-ui";

  interface AlertDialogProps {
    open?: boolean;
    defaultOpen?: boolean;
  }

  const props = defineProps<AlertDialogProps>();
  const emits = defineEmits<{
    "update:open": [value: boolean];
  }>();

  const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <AlertDialogRoot v-bind="forwarded">
    <slot />
  </AlertDialogRoot>
</template>
